module.exports = __webpack_public_path__ + "img/Wp_2068.ba35b713.png";